var _rect, _rect2, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 450,
    viewBox: "0 0 800 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#2a2a2a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 780,
    height: 430,
    fill: "none",
    stroke: "#444",
    strokeWidth: 2,
    strokeDasharray: "10,5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 200,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fill: "#666",
    textAnchor: "middle"
  }, "MISSING PREVIEW")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 250,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fill: "#555",
    textAnchor: "middle"
  }, "(Desktop Image)")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 290,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#444",
    textAnchor: "middle"
  }, "DEV MODE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderDesktop);
export default __webpack_public_path__ + "static/media/placeholder-desktop.e5d506fef094e0da5715934aa8053e82.svg";
export { ForwardRef as ReactComponent };